// extracted by mini-css-extract-plugin
export default {"modal":"ModalDialog_modal__i+d9g","modalOverlay":"ModalDialog_modalOverlay__61Zcj","modalClose":"ModalDialog_modalClose__uf-s4"};